import React from 'react';
import styled from 'astroturf/react';

import AvatarBase from 'js/social/shared/Avatar';
import { User } from 'js/social/UserCard';
import { Chain } from 'js/social/Comment/types';

const PLACEHOLDER_PHOTO = '//a.academia-assets.com/images/s65_no_pic.png';

const Container = styled.div`
  display: flex;
  gap: 8px;
`;

const BodyContainer = styled.div<{
  expanded?: boolean;
  collapsed?: boolean;
  reply?: boolean;
  more?: boolean;
}>`
  position: relative;

  &::before {
    position: absolute;
    width: 20px;
    border-left: 1px solid $ds-gray-light;
    border-bottom: 1px solid $ds-gray-light;
    border-bottom-left-radius: 8px;
  }

  &.expanded {
    &::before {
      content: '';
      height: calc(100% - 16px);
      top: 48px;
      left: -29px;
    }
  }

  &.collapsed {
    &::before {
      content: '';
      height: calc(100% - 38px);
      top: 48px;
      left: -29px;
    }
  }

  &.reply {
    &::before {
      content: '';
      height: calc(100% + 12px);
      top: 20px;
      left: -77px;
    }
  }

  &.more {
    &::before {
      content: '';
      height: calc(100% - 7px);
      top: 17px;
      left: -77px;
    }
  }
`;

const Avatar = styled(AvatarBase)`
  margin-top: 8px;
  flex-shrink: 0;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

interface Props {
  className?: string;
  commenter: User;
  commenterUrl?: string;
  chain?: Chain;
  header: React.ReactNode;
  content: React.ReactNode;
  footer?: React.ReactNode;
}

const Base: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  commenter,
  commenterUrl,
  chain,
  header,
  content,
  footer,
  children,
}) => (
  <Container className={className}>
    <Avatar
      fullName={commenter.displayName}
      photoUrl={commenter.photo || PLACEHOLDER_PHOTO}
      profileUrl={commenterUrl}
    />
    <Content>
      <BodyContainer
        expanded={chain === 'expanded'}
        collapsed={chain === 'collapsed'}
        reply={chain === 'reply'}
        more={chain === 'more'}
      >
        {header}
        {content}
        {footer}
      </BodyContainer>

      {children}
    </Content>
  </Container>
);

export default Base;
